(function () {
  var cartEndpoint = 'https://api.dooki.com.br/v2/public/shopify/cart';
  var checkoutHost = 'seguro.lamazonie.com.br';
  var loader = document.querySelector('.yampi-loader');
  var shopifyInternalDomain = loader ? loader.getAttribute('data-yampi-internal-domain') : '';
  var isAddingProduct = false;

  function showLoader() {
    if (loader) loader.style.display = 'block';
  }

  function hideLoader() {
    if (loader) loader.style.display = 'none';
  }

  function getPath(url) {
    try {
      return new URL(url, window.location.origin).pathname;
    } catch (error) {
      return '';
    }
  }

  function getCheckoutUrl(response) {
    if (!response || !response.active || !response.checkout_direct_url) return null;

    try {
      var checkoutUrl = new URL(response.checkout_direct_url);
      return checkoutUrl.protocol === 'https:' && checkoutUrl.hostname === checkoutHost ? checkoutUrl : null;
    } catch (error) {
      return null;
    }
  }

  function getCookie(name) {
    var prefix = name + '=';
    var cookies = document.cookie.split(';');

    for (var index = 0; index < cookies.length; index += 1) {
      var cookie = cookies[index].trim();
      if (cookie.indexOf(prefix) === 0) return cookie.slice(prefix.length);
    }

    return null;
  }

  function appendTrackingParams(checkoutUrl) {
    var destination = new URL(checkoutUrl);
    var source = new URL(window.location.href);
    var params = ['utm_source', 'utm_campaign', 'utm_term', 'utm_medium', 'utm_content'];
    var ga = getCookie('_ga');

    params.forEach(function (name) {
      if (source.searchParams.has(name)) {
        destination.searchParams.set(name, source.searchParams.get(name));
      }
    });

    if (ga) destination.searchParams.set('_ga', ga);
    return destination.href;
  }

  function openCartDrawer() {
    var cartDrawer = document.querySelector('m-cart-drawer');

    if (!cartDrawer || typeof cartDrawer.open !== 'function') {
      window.location.assign('/cart');
      return;
    }

    if (typeof cartDrawer.onCartDrawerUpdate === 'function') {
      cartDrawer.onCartDrawerUpdate();
    }

    cartDrawer.open();
  }

  async function startYampiCheckout() {
    showLoader();

    try {
      var cartResponse = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!cartResponse.ok) throw new Error('Não foi possível carregar o carrinho.');

      var cart = await cartResponse.json();
      if (!cart.item_count) throw new Error('O carrinho está vazio.');

      var checkoutResponse = await fetch(cartEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          shop: window.location.host,
          shopify_internal_domain: shopifyInternalDomain,
          cart_payload: cart
        })
      });

      if (!checkoutResponse.ok) throw new Error('A Yampi não respondeu ao pedido de checkout.');

      var checkout = getCheckoutUrl(await checkoutResponse.json());
      if (!checkout) throw new Error('A Yampi não retornou um checkout válido.');

      window.location.assign(appendTrackingParams(checkout));
    } catch (error) {
      hideLoader();
      console.error('[Yampi checkout]', error);
    }
  }

  async function addProductAndOpenCart(form, button) {
    if (isAddingProduct) return;

    isAddingProduct = true;
    if (button) button.disabled = true;

    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      });

      if (!response.ok) throw new Error('Não foi possível adicionar o produto ao carrinho.');

      await response.json();
      openCartDrawer();
    } catch (error) {
      console.error('[Yampi add to cart]', error);
    } finally {
      isAddingProduct = false;
      if (button) button.disabled = false;
    }
  }

  function interceptClick(event) {
    var target = event.target.closest('button, input, a');
    if (!target) return;

    var href = target.getAttribute('href');
    var hrefPath = getPath(href);
    if (hrefPath === '/checkout' || hrefPath === '/a/checkout') {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (getPath(window.location.href) === '/cart') {
        startYampiCheckout();
      } else {
        window.location.assign('/cart');
      }
      return;
    }

    var isAddButton = target.matches('button[name="add"], input[name="add"], #add-to-cart, .add-to-cart, #AddToCartText, #AddToCart, .ProductForm__AddToCart');
    if (!isAddButton) return;

    var form = target.closest('form');
    if (!form || getPath(form.action) !== '/cart/add') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addProductAndOpenCart(form, target);
  }

  function interceptSubmit(event) {
    var form = event.target;
    var path = getPath(form.action);

    if (path === '/cart/add') {
      event.preventDefault();
      event.stopImmediatePropagation();
      addProductAndOpenCart(form, event.submitter || null);
      return;
    }

    if (path === '/cart' && (!event.submitter || event.submitter.name !== 'update')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      startYampiCheckout();
    }
  }

  window.yampiClick = startYampiCheckout;
  window.getNewCheckoutURL = startYampiCheckout;
  document.addEventListener('click', interceptClick, true);
  document.addEventListener('submit', interceptSubmit, true);
})();
